<template>
  <div>
    <div class="simulator-timer">
      <div class="container">
        <a @click="$emit('show-exit-modal')" class="simulator-comeback">Выйти из симулятора</a>
      </div>
    </div>

    <div class="container" v-if="questions.length">
      <div class="flex simulator-comment">
        <div class="simulator-question">
          <img v-if="currentQuestion.question ? currentQuestion.question.image : currentQuestion.image"
               :src="`${$APP_URL}/storage/${currentQuestion.question ? currentQuestion.question.image : currentQuestion.image}`"
               class="simulator-question__image"
          >
          <div
            class="simulator-question__text"
            v-html="currentQuestion.question ? currentQuestion.question.text : currentQuestion.text"
          ></div>
          <form class="simulator-form">
            <div
              v-for="(answer, key, index) in currentQuestion.answers ? currentQuestion.answers : this.getAnswersOfQuestion(this.currentQuestion)"
              :key="key"
              class="simulator-option__block"
              :class="getAnswerClass(key, currentQuestionIndex)">
              <label :for="key">{{ index + 1 }}. {{ answer }}</label>
            </div>

            <div class="flex row-btn">
              <button
                type="button"
                class="simulator-button prev"
                :disabled="currentQuestionIndex <= 0"
                @click="goToQuestion(currentQuestionIndex - 1)"
              >К предыдущему</button>
              <button
                type="button"
                class="simulator-button"
                @click="reloadSimulator"
              >Пройти заново</button>
              <button
                type="button"
                class="simulator-button next"
                :disabled="currentQuestionIndex >= questions.length - 1"
                @click="goToQuestion(currentQuestionIndex + 1)"
              >К следующему</button>
            </div>
          </form>
        </div>
        <div class="simulator-comment__block">
          <div class="title">Комментарий</div>
          <div v-html="currentQuestion.question ? currentQuestion.question.comment : currentQuestion.comment"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QuestionErrors',
    data() {
      return {
        currentQuestionIndex: 0,
      };
    },
    computed: {
      questions() {
        return this.$store.getters.simulatorWrongQuestions;
      },
      currentQuestion() {
        return this.questions[this.currentQuestionIndex];
      },
    },
    methods: {
      goToQuestion(questionIndex) {
        this.currentQuestionIndex = questionIndex;
      },
      getAnswerClass(key) {
        const answer = this.currentQuestion.question && this.currentQuestion.answer;
        const correctAnswer = this.currentQuestion.question
          ? this.currentQuestion.question.correct_answer
          : this.currentQuestion.correct_answer;
        const isUserAnswer = key === answer;
        const isCorrectAnswer = key === correctAnswer;

        return {
          failed: isUserAnswer,
          right: isCorrectAnswer,
        };
      },
      reloadSimulator() {
        this.$router.push({
          path: '/simulator/list',
          query: {
            r: this.$route.query.r ? parseInt(this.$route.query.r, 10) + 1 : 1,
          },
        });
      },
      getAnswersOfQuestion(question) {
        const answers = {};

        for (const prop in question) {
          if (/^answer\d+/.test(prop) && this.currentQuestion[prop]) {
            answers[prop] = this.currentQuestion[prop];
          }
        }

        return answers;
      },
      keyboardNavigation(event) {
        const keys = {
          escape: 'Escape',
          enter: 'Enter',
          space: ' ',
          up: 'ArrowUp',
          down: 'ArrowDown',
          left: 'ArrowLeft',
          right: 'ArrowRight',
        };

        /* eslint-disable vue/script-indent */
        switch (event.key) {
          case keys.space: {
            this.reloadSimulator();
            break;
          }

          case keys.left: {
            if (this.currentQuestionIndex <= 0) {
              break;
            }

            this.goToQuestion(this.currentQuestionIndex - 1);
            break;
          }

          case keys.right: {
            if (this.currentQuestionIndex >= this.questions.length - 1) {
              break;
            }

            this.goToQuestion(this.currentQuestionIndex + 1);
            break;
          }

          default: {
            break;
          }
        }
      },
    },
    mounted() {
      window.addEventListener('keyup', this.keyboardNavigation);
    },
  };
</script>
